import { CanGoOutAloneCondition } from '../../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { CanGoOutAloneConditionInput } from '../../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'

export const mapCanGoOutAloneConditionIntoInput = (
  data: CanGoOutAloneCondition
): CanGoOutAloneConditionInput => {
  const { countries, formulas, maxAge, minAge } = data
  return {
    maxAge,
    minAge,
    countries: countries.map((country) => country.id),
    formulas: formulas.map((formula) => formula.id)
  }
}
